import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import './Styling/ContactForm.css'

const ContactForm = () => {
    const { user, logout, isAuthenticated } = useAuth0();
    const serverName='https://api.myemployeemanual.com'

    async function sendSupport(name, email, msgType, message){
        console.log(message);
        const sendSupport=await fetch(`${serverName}/sendSupport?userID=${user.name}&name=${name}&email=${email}&msgType=${msgType}&message=${message}`, {
            method: 'POST',
        });
    }

    return(
        <div>
            <div className='contactHeader'>
                <h1>Contact Us</h1>
            </div>
            <div className='support'>
                <h2>Contact Form</h2>
                <form className='supportForm'>
                    <div className='inElem'>
                        <label htmlFor='name'>Name:</label>
                        <input type='text' id='name' name='name' required/>
                    </div>
                    <br />
                    <div className='inElem'>
                        <label htmlFor='email'>Email:</label>
                        <input type='email' id='email' name='email' placeholder={isAuthenticated?user.email:"example@example.com"}/>
                    </div>
                    <br />
                    <div className='inElem'>
                        <label htmlFor='msgType'>Message Type:</label>
                        <select id='msgType' name='msgType'>
                            <option value='query'>Question</option>
                            <option value='feedback'>Feedback</option>
                            <option value='bug'>Bug</option>
                            <option value='other'>Other</option>
                        </select>
                    </div>
                    <br />
                    <div className='inElem'>
                        <label htmlFor='query'>Message:</label>
                        <textarea id='query' name='query' required></textarea>
                    </div>
                    <button className='submitButton' type='submit' onClick={() => sendSupport(user.name, document.getElementById('name').value,document.getElementById('email').value,document.getElementById('msgType').value,document.getElementById('query').value)}>Submit</button>
                                <p className="noticeAtCollection" style={{marginTop: "0.75rem", fontSize: "0.78rem", color: "#9ca3af"}}>
                    We collect the information above to respond to your inquiry, as described in our <a href="/privacyPolicy" style={{color:"#5FC5FA"}}>Privacy Policy</a>.
                </p>
                </form>
            </div>
        </div>
    )
}

export default ContactForm;